import { z } from "zod";
export const timestamp = z.union([
  z.date(),
  z
    .string()
    // @ts-ignore
    .refine(isRFC3339)
    .transform((s) => new Date(s)),
]);
type TimestampInput = z.input<typeof timestamp>;
var dateFullYear = /[0-9]{4}/;
var dateMonth = /(0[1-9]|1[0-2])/;
var dateMDay = /([12]\d|0[1-9]|3[01])/;
var timeHour = /([01][0-9]|2[0-3])/;
var timeMinute = /[0-5][0-9]/;
var timeSecond = /([0-5][0-9]|60)/;
var timeSecFrac = /(\.[0-9]+)?/;
var timeNumOffset = new RegExp(
  "[-+]".concat(timeHour.source, ":").concat(timeMinute.source)
);
var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
var partialTime = new RegExp(
  ""
    .concat(timeHour.source, ":")
    .concat(timeMinute.source, ":")
    .concat(timeSecond.source)
    .concat(timeSecFrac.source)
);
var fullDate = new RegExp(
  ""
    .concat(dateFullYear.source, "-")
    .concat(dateMonth.source, "-")
    .concat(dateMDay.source)
);
var fullTime = new RegExp(
  "".concat(partialTime.source).concat(timeOffset.source)
);
var rfc3339 = new RegExp(
  "^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$")
);
function isRFC3339(str: unknown) {
  return typeof str === "string" && rfc3339.test(str);
}
